import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { TourService } from '../../../services/tour.service';

@Component({
  selector: 'app-modal-help',
  templateUrl: './modal-help.component.html',
  styleUrls: ['./modal-help.component.scss']
})
export class ModalHelpComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ModalHelpComponent>,
    public tour: TourService
  ) { }

  closeDialog() {
    this.dialogRef.close();
  }

  openTour() {
    this.tour.showTour();
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/modals/modal-help/modal-help.component.ts